import { render } from "./VerifyOtp.vue?vue&type=template&id=19a45a78"
import script from "./VerifyOtp.vue?vue&type=script&lang=js"
export * from "./VerifyOtp.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__